export default __webpack_public_path__ + "static/media/OceanEyes_img.631f413f.jpg";